export enum EXPERT_STATUS {
  PENDING = "Pending",
  ACCEPT = "Accept",
  REJECT = "Reject"
}

export enum SoftwareReviewVariantEnum {
  ReviewForm = "review_form",
  EmptyState = "empty_state",
  ManualReview = "manual_review",
  UnifiedPage = "unified_page"
}

export enum REFERRAL_STATES {
  CANDIDATE = "Candidate",
  ACCEPT = "Accept",
  REJECT = "Reject",
  ALLEXPERTS = "AllExperts"
}

export enum EXPERT_FOLLOW_UP_STEPS {
  ENGAGE_EXPERT = "EngageExpert",
  SEND_ADDITIONAL_QUESTIONS = "SendAdditionalQuestions"
}

export enum ExpertRateCardType {
  AdHoc = "AdHoc",
  Package = "Package"
}

export enum CONTACT_TYPE_FILTERS_ENUM {
  ALL_CONTACT_TYPES = "AllStatus",
  UN_CONTACTED = "Uncontacted",
  CONTACTED = "Contacted",
  FIRST_FOLLOW_UP = "FirstFollowUp",
  SECOND_FOLLOW_UP = "SecondFollowUp",
  REPLIED = "Replied",
  REJECTED_DECLINED = "RejectedDeclined"
}

export enum CONTACT_METHOD_FILTERS_ENUM {
  ALL_CONTACT_METHODS = "AllContactMethods",
  EMAIL_AND_PHONE = "EmailAndPhone",
  EMAIL = "Email",
  PHONE = "Phone",
  NO_CONTACT_INFO = "NoContactMethod"
}

export enum CONTACT_TYPE_ENUM {
  UN_CONTACTED = "Uncontacted",
  CONTACTED_BY_PHONE = "ContactedByPhone",
  CONTACTED_BY_EMAIL = "ContactedByEmail",
  FIRST_FOLLOW_UP_BY_PHONE = "FirstFollowUpByPhone",
  FIRST_FOLLOW_UP_BY_EMAIL = "FirstFollowUpByEmail",
  SECOND_FOLLOW_UP_BY_PHONE = "SecondFollowUpByPhone",
  SECOND_FOLLOW_UP_BY_EMAIL = "SecondFollowUpByEmail",
  REPLIED = "Replied",
  REJECTED_DECLINED = "RejectedDeclined"
}

export enum EXPERT_TYPE {
  EXTERNAL = "External",
  INTERNAL = "Internal"
}

export enum EXPERT_APPLICATION_STEPS {
  ENGAGEMENT_AGREEMENT = "EngagementAgreement",
  SCREENING_QUESTIONS = "ScreeningQuestions",
  COMPLIANCE_QUESTIONS = "ComplianceQuestions",
  AVAILABILITY = "ExpertAvailability",
  COMPANY_VALIDATION = "CompanyValidation",
  VENDOR_SCREENING = "CustomerInsight",
  APPLICATION_SUBMITTED = "ApplicationSubmitted",
  SOFTWARE_REVIEW = "SoftwareReview",
  REFER_PEER = "ReferPeer"
}

export type CANOPY_APPLICATION_STEPS = Extract<
  EXPERT_APPLICATION_STEPS,
  | EXPERT_APPLICATION_STEPS.ENGAGEMENT_AGREEMENT
  | EXPERT_APPLICATION_STEPS.COMPLIANCE_QUESTIONS
  | EXPERT_APPLICATION_STEPS.COMPANY_VALIDATION
  | EXPERT_APPLICATION_STEPS.SOFTWARE_REVIEW
>;

export type PROJECT_APPLICATION_STEPS = EXPERT_APPLICATION_STEPS;

export enum OnboardingPhase {
  ContactDetails = "ContactDetails",
  WorkHistory = "WorkHistory",
  SoftwareReview = "SoftwareReview",
  Suggestions = "Suggestions",
  AdditionalReview = "AdditionalReview",
  PaymentDetails = "PaymentDetails"
}

export enum NEW_EXPERT_DASHBOARD_ACTION_TYPE {
  REWARDS_PROGRAM = "rewards_program",
  REFERRAL_NUDGE = "referral_nudge",
  REWARDS_DISABLED = "rewards_disabled",
  COMPLIANCE_TRAINING = "compliance_training",
  SOFTWARE_EXPERIENCE = "software_experience",
  OUTDATED_REVIEW = "outdated_review",
  PENDING_TASK = "pending_task",
  WORK_HISTORY = "work_history",
  LINKEDIN = "linkedin"
}

export enum EXPERT_ONBOARDING_STEP {
  LINKEDIN = "linkedin",
  WORK_EXPERIENCE = "work_experience",
  COMPLIANCE = "compliance",
  REWARDS = "rewards"
}

export enum NEW_EXPERT_DASHBOARD_WHATS_MISSING_ACTION_TYPE {
  TAKE_TRAINING = "take_training",
  ADD_EXPERIENCE = "add_experience",
  ADD_MORE = "add_more",
  ADD_POSITION = "add_position"
}

export enum NEW_EXPERT_DASHBOARD_ACTION_BADGE_TYPE {
  RECOMMENDED = "recommended",
  NEW = "new",
  MANDATORY = "mandatory",
  BETA = "beta",
  IMPORTANT = "important"
}

export enum NEW_EXPERT_DASHBOARD_BADGE_COLOR {
  WARNING = "warning",
  SUCCESS = "success",
  ERROR = "error",
  PROCESSING = "processing"
}

export enum SOFTWARE_REVIEW_SOURCE {
  EXPERT_DASHBOARD_OUTDATED_REVIEW = "expert_dashboard_outdated_review",
  UNIFIED_REVIEWS_ADD_YOUR_OWN = "unified_reviews_add_your_own",
  EXTERNAL_EXPERT_ONBOARDING = "external_expert_onboarding",
  REWARDS_ENROLL_PROGRESS = "rewards_enroll_progress",
  REWARDS_ENROLL_PROGRESS_MODAL = "rewards_enroll_progress_modal",
  REWARDS_AI_ANALYSIS = "rewards_ai_analysis",
  REWARDS_TIPS_CAROUSEL = "rewards_tips_carousel",
  EXPERT_PROFILE_REVIEWS = "expert_profile_reviews",
  SOFTWARE_REVIEWS_PAGE = "software_reviews_page",
  REWARDS_PROGRAM_CARD = "rewards_program_card",
  ADMIN_SHARED_LINK = "admin_shared_link",
  EXPERT_EXPERIENCE_UPGRADE = "expert_experience_upgrade",
  REWARDS_UNSUBSCRIBED_PAGE = "rewards_unsubscribed_page",
  EXPERT_DASHBOARD_REWARDS_JOIN = "expert_dashboard_rewards_join",
  PAYMENTS_REWARDS_JOIN = "payments_rewards_join",
  EXPERIENCE_REWARDS_BANNER = "experience_rewards_banner"
}
